module.exports = __webpack_public_path__ + "static/media/latb-tech.dce4c6a7.jpg";